import React, { useEffect } from 'react';

const Social = () => {
  useEffect(() => {
    // Load Instagram embed script
    const script = document.createElement('script');
    script.src = "https://www.instagram.com/embed.js";
    script.async = true;
    script.onload = () => {
      if (window.instgrm) {
        window.instgrm.Embeds.process();
      }
    };
    document.body.appendChild(script);
  }, []);

  return (
    <section className="bg-black text-white py-12 px-4 font-[Roboto]">
      <h2 className="text-4xl font-bold text-center text-orange-500 mb-12">Our Latest Instagram Posts</h2>
      
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
        {/* Post 1 */}
        <div className="bg-[#0f0f0f] border border-orange-500 rounded-xl p-4 shadow-lg flex justify-center items-center min-h-[450px]">
          <blockquote
            className="instagram-media w-full"
            data-instgrm-permalink="https://www.instagram.com/p/DMQTdq-tVfZ/"
            data-instgrm-version="14"
            style={{ backgroundColor: "#0f0f0f", width: '100%' }}
          ></blockquote>
        </div>

        {/* Post 2 */}
        <div className="bg-[#0f0f0f] border border-orange-500 rounded-xl p-4 shadow-lg flex justify-center items-center min-h-[450px]">
          <blockquote
            className="instagram-media w-full"
            data-instgrm-permalink="https://www.instagram.com/p/DMT74OKoLQA/"
            data-instgrm-version="14"
            style={{ backgroundColor: "#0f0f0f", width: '100%' }}
          ></blockquote>
        </div>

        {/* Post 3 */}
        <div className="bg-[#0f0f0f] border border-orange-500 rounded-xl p-4 shadow-lg flex justify-center items-center min-h-[450px]">
          <blockquote
            className="instagram-media w-full"
            data-instgrm-permalink="https://www.instagram.com/p/DMb0RJ8yKiV/"
            data-instgrm-version="14"
            style={{ backgroundColor: "#0f0f0f", width: '100%' }}
          ></blockquote>
        </div>
      </div>
    </section>
  );
};

export default Social;
